import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["addressInput", "zipcodeInput", "cityInput", "latInput", "lngInput"]
  static outlets = ["form--google-autocomplete-input"]

  formGoogleAutocompleteInputOutletConnected(outlet) {
    outlet.selectGooglePlace = this.selectGooglePlace.bind(this)
  }

  selectGooglePlace(placeData) {
    this.placeData = placeData
    this.formGoogleAutocompleteInputOutlet.inputTarget.value = placeData.formatted_address
    this.addressInputTarget.value = this.streetAddress()
    this.zipcodeInputTarget.value = this.addressComponent("postal_code")?.long_name || ""
    this.cityInputTarget.value = this.cityName()
    this.latInputTarget.value = placeData.geometry.location.lat()
    this.lngInputTarget.value = placeData.geometry.location.lng()
    this.submit()
  }

  clearAddressWhenBlank(event) {
    if (event.currentTarget.value.trim() !== "") return

    this.locationInputs.forEach(input => { input.value = "" })
  }

  submitWhenCleared(event) {
    if (event.currentTarget.value.trim() === "") this.submit()
  }

  submit() {
    this.addressInputTarget.form.requestSubmit()
  }

  streetAddress() {
    const streetNumber = this.addressComponent("street_number")?.long_name || ""
    const route = this.addressComponent("route")?.long_name || ""

    return `${streetNumber} ${route}`.trim() || this.placeData.formatted_address
  }

  cityName() {
    return this.addressComponent("locality")?.long_name ||
      this.addressComponent("postal_town")?.long_name ||
      this.addressComponent("administrative_area_level_3")?.long_name ||
      this.addressComponent("administrative_area_level_2")?.long_name ||
      ""
  }

  addressComponent(type) {
    return this.placeData.address_components?.find(component => component.types.includes(type))
  }

  get locationInputs() {
    return [this.addressInputTarget, this.zipcodeInputTarget, this.cityInputTarget, this.latInputTarget, this.lngInputTarget]
  }
}
